module.exports = __webpack_public_path__ + "img/3.afd90ce3.png";